import { render, staticRenderFns } from "./UserFChPassword.vue?vue&type=template&id=8be6a358"
import script from "./UserFChPassword.vue?vue&type=script&lang=js"
export * from "./UserFChPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports